const state = {
  media: '',
  isVideo: false,
  open: false,
  color: 'colorBlack'
}

const getters = {
  openMedia: state => state.open
}

const actions = {
  openMediaPopup: ({ commit }, { media, isVideo = false, color = 'colorBlack' }) => {
    commit('openMediaPopup', {
      media, isVideo, color
    });
  },
  closeMediaPopup: ({ commit }) => {
    commit('closeMediaPopup');
  }
}

const mutations = {
  openMediaPopup: (state, { media, isVideo, color }) => {
    state.media = media;
    state.isVideo = isVideo;
    state.color = color;
    state.open = true;
  },
  closeMediaPopup: (state) => {
    state.open = false;
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
